export default [
    {
        path: '/news',
        name: 'News',
        component: () => import('@/views/News/NewsList.vue'),
        meta: { permission: 'news.view' }
    },
    {
        path: '/news/new',
        name: 'NewsCreate',
        component: () => import('@/views/News/NewsCreate.vue'),
        meta: { permission: 'news.create' }
    },
    {
        path: '/news/:id',
        name: 'NewsView',
        component: () => import('@/views/News/NewsView.vue'),
        meta: { permission: 'news.view' }
    },
    {
        path: '/news/:id/edit',
        name: 'NewsEdit',
        component: () => import('@/views/News/NewsEdit.vue'),
        meta: { permission: 'news.update' }
    },
    {
        path: '/news/categories',
        name: 'NewsCategories',
        component: () => import('@/views/News/NewsCategories.vue'),
        meta: { permission: 'news-categories.view' }
    }
]
